/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import moment from 'moment';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export class Submission {
    id;
    userId;
    assignmentId;
    name;
    createdAt;
    updatedAt;
    fileTree;
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    constructor(id, userId, assignmentId, name, createdAt, updatedAt, fileTree) {
        this.id = id;
        this.userId = userId;
        this.assignmentId = assignmentId;
        this.name = name;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
        this.fileTree = fileTree;
        Object.freeze(this);
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    static fromResponse(id, item, fileTree) {
        return new Submission(id, item.userId, item.assignmentId, item.name, item.createdAt, item.updatedAt, fileTree);
    }
    /**
     * Given an EditorSession it will return a Submission.
     *
     * @param session Is the EditorSession object.
     * @param fileTree Is the given file tree.
     * @returns A Submission.
     */
    static fromSmithy(session, fileTree) {
        return new Submission(session.id, parseInt(session.userId, 10), parseInt(session.assignmentId, 10), session.name, moment(session.createdAt), moment(session.updatedAt), fileTree);
    }
    /**
     * Set a new file tree.
     *
     * @param fileTree The new file tree.
     * @returns A new instance of this class.
     */
    updateFileTree(fileTree) {
        return new Submission(this.id, this.userId, this.assignmentId, this.name, this.createdAt, this.updatedAt, fileTree);
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    addItem(...items) {
        return this.updateFileTree(this.fileTree.addItem(...items));
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    deleteItem(...items) {
        return this.updateFileTree(this.fileTree.deleteItem(...items));
    }
}
